import { render, staticRenderFns } from "./b-confirm-professional.vue?vue&type=template&id=53ab85e8&"
import script from "./b-confirm-professional.vue?vue&type=script&lang=js&"
export * from "./b-confirm-professional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports